/**
 * HotkeyProvider — mounted ONCE at the app root (main.tsx).  Owns the global `?`
 * shortcut and renders the cheat sheet (CLAUDE.md standing rule 14, §18.6,
 * ADR-0013).  It does NOT own the registry — bindings register themselves through
 * the module-level store via `useHotkeys`, so a form needs no provider in scope.
 */
import { useState, type ReactNode } from 'react';
import { useHotkeys } from './useHotkeys';
import type { HotkeyDef } from './hotkeyStore';
import { HotkeyCheatSheet } from './HotkeyCheatSheet';
import { HotkeyCommandPalette } from './HotkeyCommandPalette';

export function HotkeyProvider({ children }: { children?: ReactNode }) {
  const [sheet, setSheet] = useState(false);
  const [palette, setPalette] = useState(false);

  const defs: HotkeyDef[] = [
    // `?` toggles the cheat sheet; Ctrl/⌘+K toggles the command palette. Each
    // closes the other so only one overlay is ever open. mod+k is a modifier
    // combo, so it fires even while a field is focused (open from anywhere).
    { combo: '?', label: 'Show keyboard shortcuts', group: 'Global', order: 1, run: () => { setPalette(false); setSheet((o) => !o); } },
    { combo: 'mod+k', label: 'Command palette', group: 'Global', order: 2, run: () => { setSheet(false); setPalette((o) => !o); } },
  ];
  useHotkeys(defs);

  return (
    <>
      {children}
      {sheet && <HotkeyCheatSheet onClose={() => setSheet(false)} />}
      {palette && <HotkeyCommandPalette onClose={() => setPalette(false)} />}
    </>
  );
}
